import { ActiveFilters } from '@/types/filter/ActiveFilters.types';

/**
 * Converts search params to ActiveFilters format
 * Handles URL query string parsing with proper array and boolean handling
 */
export function parseSearchParamsToActiveFilters(searchParams: URLSearchParams): ActiveFilters {
    const activeFilters: ActiveFilters = {};

    // Ignored params that are not filters
    const ignoredParams = ['date', 'locale', 'sort'];

    for (const [key, value] of searchParams.entries()) {
        if (!ignoredParams.includes(key)) {
            const existingValue = activeFilters[key];
            if (existingValue) {
                // Convert to array if multiple values exist
                if (Array.isArray(existingValue)) {
                    existingValue.push(value);
                } else {
                    activeFilters[key] = [existingValue, value];
                }
            } else if (['showingTagIds', 'cinemaRoomIds', 'genreIds'].includes(key)) {
                activeFilters[key] = [value];
            } else {
                activeFilters[key] = value;
            }
        }
    }

    return activeFilters;
}

/**
 * Converts ActiveFilters to URL search params
 */
export function activeFiltersToSearchParams(
    activeFilters: ActiveFilters,
    preservedParams?: Record<string, string>
): URLSearchParams {
    const searchParams = new URLSearchParams();

    // Add preserved params first (like date)
    if (preservedParams) {
        for (const [key, value] of Object.entries(preservedParams)) {
            searchParams.append(key, value);
        }
    }

    // Add filter params
    for (const [key, value] of Object.entries(activeFilters)) {
        if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
        } else {
            searchParams.append(key, value);
        }
    }

    return searchParams;
}
